import React, { useState } from "react";
import MapChart from "./MapChart";

const TooltipComponent = ({ stateWiseNationalParks }) => {
  const [tooltipName, setTooltipName] = useState("");

  return (
    <div>
      <MapChart
        stateWiseNationalParks={stateWiseNationalParks}
        setTooltipName={setTooltipName}
      />

      {tooltipName && (
        <div className="tooltip">
          <p>{tooltipName}</p>
        </div>
      )}
    </div>
  );
};

export default TooltipComponent;
